import styled from 'styled-components';
import { animated } from 'react-spring';

export default animated(styled.div`
  position: relative;
`);
